import PropTypes from "prop-types";
import React from "react";

import { withContainerContext } from "../../components/container/ContainerContext";
import Dimensions, { scalePixelsToFontSize } from "../../constants/styles/dimensions";
import { PropTypeShapes } from "../../types";
import { withCharacterContext } from "../character/CharacterContext";
import PrintPreviewPdfViewer from "./PrintPreviewPdfViewer";

const PrintPreviewBody = props => {
  const rect = props.containerRect;
  const SCALED_MODAL_FOOTER_HEIGHT = scalePixelsToFontSize(
    Dimensions.MODAL_FOOTER_HEIGHT,
    props.characterContext.getFontSize()
  );
  const containerSize = {
    width: rect ? rect.width - 300 : 580,
    height: rect ? rect.height - Dimensions.MODAL_HEADING_HEIGHT - SCALED_MODAL_FOOTER_HEIGHT : 586
  };

  const containerHeight = containerSize.height - Dimensions.PRINT_PREVIEW_NAVIGATION_HEIGHT;

  const maxPreviewSize = {
    width: props.showFullSize ? props.pageInfo.paperWidth : containerSize.width,
    height: props.showFullSize ? props.pageInfo.paperHeight : containerHeight
  };

  const xRatio = maxPreviewSize.width / props.pageInfo.paperWidth;
  const yRatio = maxPreviewSize.height / props.pageInfo.paperHeight;
  const minRatio = Math.min(xRatio, yRatio);
  const previewSize = {
    width: props.pageInfo.paperWidth * minRatio,
    height: props.pageInfo.paperHeight * minRatio
  };

  const isPreviewBiggerThanContainer = previewSize.width > containerSize.width || previewSize.height > containerHeight;

  return (
    <div className="printPreviewBody">
      <PrintPreviewPdfViewer
        base64Data={props.base64Data}
        pageInfo={props.pageInfo}
        containerSize={containerSize}
        previewSize={previewSize}
        showFullSize={isPreviewBiggerThanContainer}
        errorMessage={props.errorMessage}
        showNavigation={props.showNavigation}
      />
      {props.previewOptions}
    </div>
  );
};

PrintPreviewBody.propTypes = {
  pageInfo: PropTypes.object,
  base64Data: PropTypes.string,
  errorMessage: PropTypes.string,

  showNavigation: PropTypes.bool,
  showFullSize: PropTypes.bool,

  previewOptions: PropTypeShapes.elementOrArray,

  // From character context
  characterContext: PropTypes.object.isRequired,

  containerRect: PropTypeShapes.flatRect
};

export default withContainerContext(withCharacterContext(PrintPreviewBody));
